var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o2o-helper{padding:0 1.25rem}.o2o-helper .info{margin:0 -1.25rem;text-align:center}.o2o-helper .help{margin-top:1.25rem;margin-bottom:-.75rem}.o2o-helper .help .introduce-info{width:70%;display:inline-block}.o2o-helper .help .zhj-img{width:1.64rem;height:3.826667rem;float:right;background-image:url(" + escape(require("../../static/img/biaoge_image.png")) + ");background-size:cover;background-repeat:no-repeat}.o2o-helper .help .img{width:100%;height:100%}.o2o-helper .bar-code-bg{text-align:center;margin:1rem 0 .6rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f312c0f","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/O2OHelper.vue
// module id = 421
// module chunks = 0